import React from 'react';
import './CategoryBar.css';
import CategoryButton from './CategoryButton';


const CategoryBar = ({categories, currentCategory}) => {

  // console.log("카테고리 바 컴포넌트 currentCategory: ", currentCategory);
  return (
  <div className="category-bar">
    <div className="category-button-container">
      {categories.map((category) => (
        <CategoryButton key={category.id} category={category} currentCategory={currentCategory}/>   
      ))}
    </div>
  </div>)
};

export default CategoryBar; 